// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2J_ZE","large":"styles_large__2IzUQ"};